import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Confluence Standard Add Payment Modal
 * (Confluence in trial or predunning, not invoiceable, can add payment).
 */
export function isEligibleForConfluenceStandardAddPaymentModal(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		invoiceableStatus,
		canAddPaymentDetails,
		isInCollection,
	} = context;

	return Boolean(
		!isInCollection &&
		isEditionOneOf(edition, ['standard']) &&
		product === 'confluence' &&
		(isInTrial || isInPredunning) &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails,
	);
}
